// theme.ts
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeOptions } from '@mui/material/styles/createTheme';

export const commonThemeOptions: ThemeOptions = {
  typography: {
    fontFamily: "'BDO Grotesk', sans-serif",
    allVariants: {
      letterSpacing: '-0.02em',
    },
  },
  palette: {
    primary: {
      main: '#354EEF',
      light: '#7CAAD8',
      dark: '#3b89f7',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#697399',
      contrastText: '#ffffff',
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 900,
      lg: 1200,
      xl: 1600,
    },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: "'BDO Grotesk', sans-serif",
          letterSpacing: '-0.02em',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0px) scale(0.98)',
          },
          '&.MuiButton-containedSecondary:hover': {
            backgroundColor: '#5969A4',
          },
        },
      },
    },
  },
};

let theme = createTheme(commonThemeOptions);
theme = responsiveFontSizes(theme);

export default theme;
